import React, {Component} from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface ModalDeleteDashboardProps {
  show: boolean,
  onHandleClose: Function,
  onDeleteDashboard: Function,
  dashboardInstance: any
}

interface ModalDeleteDashboardState {

}

class ModalDeleteDashboard extends Component<ModalDeleteDashboardProps, ModalDeleteDashboardState> {
  constructor(props: any) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleDeleteDashboard = this.handleDeleteDashboard.bind(this);
  }

  handleClose() {
    const { onHandleClose} = this.props;
    onHandleClose();	
  }

  handleDeleteDashboard() {
    const { onDeleteDashboard, dashboardInstance } = this.props;
    onDeleteDashboard(dashboardInstance);
  }
  
  render() {
    const { show, dashboardInstance } = this.props;
    if (!dashboardInstance) {
      return <div></div>;
    }
    return (
      <Modal
        size="lg"
        show={show}
        centered
        onHide={this.handleClose}
      >
      <Modal.Header closeButton>
        <Modal.Title>Delete Dashboard - {dashboardInstance.name || 'Unknown Dashboard'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
          <p>Are you sure you want to delete this Dashboard?</p>
        <Alert variant="warning">Dashboard will be instantly deleted from the database.</Alert>
        </Modal.Body>			

      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
        <Button variant="danger" onClick={this.handleDeleteDashboard}>Delete Dashboard</Button>
      </Modal.Footer>	

      </Modal>			
    )
  }
}

export default ModalDeleteDashboard;